import { render } from "./Chevron.vue?vue&type=template&id=671d397c"
import script from "./Chevron.vue?vue&type=script&lang=js"
export * from "./Chevron.vue?vue&type=script&lang=js"

import "./Chevron.vue?vue&type=style&index=0&id=671d397c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__